import $ from 'jquery';

const defaults = {
  selector: '.node-inner',
  linkLocation: '.link-read-more a',
};

function Redirect(element, options) {
  this.$element = $(element);
  this.settings = Object.assign(defaults, options);
  this.click = this.click.bind(this);
  this.listen();
}

Redirect.prototype = {
  listen() {
    this.$element.find(this.settings.selector).on('click', this.click);
  },
  click(event) {
    event.preventDefault();
    event.stopPropagation();
    const url = $(event.currentTarget).find(this.settings.linkLocation).attr('href');
    window.location.href = url;
  },
};

export default Redirect;
